import React from "react";
import { useNavigate } from "react-router-dom";
import CatalogueList from "./components/CatalogueList";
import ServiceAuctionDetailsAndTimeSlot from "./components/ServiceAuctionDetailsAndTimeSlot";
import ServiceLotCollection from "./components/ServiceLotCollection";
function SingleServiceAuctionDetails() {
    const naviagte = useNavigate();

    return (
        <div>
            <span className="valign-wrapper gap-1">
                <span
                    className={`material-icons pointer`}
                    onClick={() => naviagte("/")}
                >
                    west
                </span>
                <h4>Auction Detail</h4>
            </span>
            <div className={`flex gap-1 column`}>
                <ServiceAuctionDetailsAndTimeSlot />
                <ServiceLotCollection />
                <CatalogueList />
            </div>
        </div>
    );
}

export default SingleServiceAuctionDetails;
